// extracted by mini-css-extract-plugin
export default {"table_wrapper":"BiayaTambahan_table_wrapper__OWlIu"};